import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import {
  calculateCashAtDataLevel,
  isAbleToShowCashColumn,
} from "./CashCellRenderer";

// LQC-2216: raw number only - no currency symbol and no thousands separators so it pastes as a number.
export function formatCashForCopy(params: any): string {
  if (!params.data) {
    return "";
  }

  const { isOp, isLeg, isER, isOutright, fullTradeData } =
    returnAllTradeDetailsFromGenericParams(params);

  const thisTrade =
    tradeDataStore
      .getState()
      .tradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  if (!thisTrade) {
    return "";
  }

  if (
    !isAbleToShowCashColumn({ params, thisTrade, isOp, isLeg, isER, isOutright })
  ) {
    return "";
  }

  const value = calculateCashAtDataLevel(
    params,
    thisTrade,
    isOp,
    isLeg,
    isER,
    isOutright,
  );

  if (value == null || value === "") {
    return "";
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return "";
  }

  // Sign is carried by the "Dealer Pays"/"Dealer Receives" text, matching the display.
  return Math.abs(numericValue).toFixed(2);
}

// AG Grid valueFormatter for the Unwind Amount value column.
export function cashCellValueFormatter(params: any): string {
  return formatCashForCopy(params);
}
